import React from 'react';
type BrandMarkProps = {
  size?: number;
  className?: string;
};

/**
 * Rising Talent Partners symbol: a small talent network rising to a gold apex.
 * Lines and lower nodes use currentColor so the mark adapts to navy or white contexts.
 */
export function BrandMark({
  size = 32,
  className = ''
}: BrandMarkProps) {
  return <svg width={size} height={size} viewBox="0 0 36 36" fill="none" aria-hidden="true" className={`shrink-0 ${className}`} data-id="element-58" data-mp="olskposidmop">
      <g stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-59" data-mp="1h8de0usjo8uw">
        <path d="M7 28 L16 19 L28 8" data-id="element-60" data-mp="1choi939u0ppy" />
        <path d="M16 19 L25 25 L28 8" data-id="element-61" data-mp="1cglvn7jjl9fu" />
        <path d="M7 28 L25 25" data-id="element-62" data-mp="17j3i13uky61i" />
      </g>
      <circle cx="7" cy="28" r="2.1" fill="currentColor" data-id="element-63" data-mp="17i248rm6j5g3" />
      <circle cx="16" cy="19" r="2.1" fill="currentColor" data-id="element-64" data-mp="24yhguzxws4ku" />
      <circle cx="25" cy="25" r="2.1" fill="currentColor" data-id="element-65" data-mp="24zshiqw24w7q" />
      <circle cx="28" cy="8" r="3.4" fill="#D5B46B" data-id="element-66" data-mp="207ivhly2cgaq" />
    </svg>;
}